var render = function render(_c,_vm){return (
    _vm.$options.isValid(_vm.props.checkValid)
      ? !_vm.props.noValid
      : _vm.props.noInvalid
        ? false
        : true
  )?_c('small',[_c('span',{class:[
      _vm.$options.isValid(_vm.props.checkValid) ? 'valid' : _vm.props.invalidColor,
      'px-2 mx-1 entsys--chip'
    ],staticStyle:{"color":"white"}},[_vm._v("\n    "+_vm._s(_vm.$options.isValid(_vm.props.checkValid) ? _vm.props.valid : _vm.props.invalid)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }